import clsx from "clsx";
import { Skeleton } from "@/components/ui/skeleton";

interface UnitItemLoadingProps {
    layout: "grid" | "row";
}
export const UnitItemLoading = ({ layout = "row" }: UnitItemLoadingProps) => {
    return (
        <div
            className={clsx(
                "unit-item",
                "unit-item--loading",
                `unit-item--${layout}`,
            )}
        >
            <div className="unit-item__image">
                <Skeleton className="tw:h-[75px] tw:w-[75px]" />
            </div>
            <div className="unit-item__dimension">
                <Skeleton className="tw:h-4 tw:w-[100px]" />
            </div>
            <div className="unit-item__category">
                <Skeleton className="tw:h-4 tw:w-[100px]" />
            </div>
            <div className="unit-item__features">
                <ul className="unit-item-features">
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                    <li className="unit-item-features__item">
                        <Skeleton className="tw:h-4 tw:mb-2 tw:w-[120px]" />
                    </li>
                </ul>
            </div>
            <div className="unit-item__promotions">
                <Skeleton className="tw:h-4 tw:w-[200px]" />
            </div>
            <div className="unit-item__urgency">
            </div>
            <div className="unit-item__price">
                <Skeleton className="tw:h-4 tw:mb-2 tw:w-[100px]" />
                <Skeleton className="tw:h-4 tw:w-[100px]" />

            </div>
            <div className="unit-item__action">
                <Skeleton className="tw:h-8 tw:w-[75px]" />
            </div>
        </div>
    );
};
